import { render, staticRenderFns } from "./NCascader.vue?vue&type=template&id=fb0f47bc&scoped=true"
import script from "./NCascader.vue?vue&type=script&lang=ts&setup=true"
export * from "./NCascader.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f47bc",
  null
  
)

export default component.exports